import { api } from "core";

const getSchoolsReport = (school) =>
  api.instance
    .get(`${school}/activitiesReport/schools`)
    .then(({ data }) => data);

export default getSchoolsReport;
